import { render } from "./SeatFareUpdateModal.vue?vue&type=template&id=e15ec2e8"
import script from "./SeatFareUpdateModal.vue?vue&type=script&lang=js"
export * from "./SeatFareUpdateModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__